import { isCarStore } from "./storeCategory"

const STOREFRONT_BASE_URL = "https://store.gestock.tech"
const CAR_STOREFRONT_BASE_URL = "https://www.mavoiture.net"
const MONGO_OBJECT_ID_PATTERN = /^[a-f0-9]{24}$/i

function getBrowserHostname() {
  if (typeof window === "undefined") return ""
  return String(window.location.hostname || "").trim().toLowerCase()
}

function sanitizeSegment(value: any) {
  return String(value || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")
}

function encodeHexToBase64Url(hexValue: string) {
  if (!MONGO_OBJECT_ID_PATTERN.test(hexValue) || typeof btoa !== "function") {
    return hexValue
  }

  const pairs = hexValue.match(/.{1,2}/g) || []
  const binary = pairs.map((pair) => String.fromCharCode(parseInt(pair, 16))).join("")

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "")
}

export function getStorefrontIdentifier(store: any) {
  const preferredIdentifier = sanitizeSegment(
    store?.publicStoreSlug ||
      store?.storeSlug ||
      store?.slug ||
      store?.publicSlug
  )

  if (preferredIdentifier) return preferredIdentifier

  const rawStoreId = sanitizeSegment(store?._id || store?.id)
  return encodeHexToBase64Url(rawStoreId)
}

export function buildStorefrontUrl(store: any) {
  const identifier = getStorefrontIdentifier(store)
  if (!identifier) return ""
  if (isCarStore(store)) {
    return `${CAR_STOREFRONT_BASE_URL}/parc/${identifier}`
  }
  return `${STOREFRONT_BASE_URL}/${identifier}`
}

export function buildStorefrontShortUrl(store: any) {
  const identifier = getStorefrontIdentifier(store)
  if (!identifier) return ""
  if (isCarStore(store)) {
    return `${CAR_STOREFRONT_BASE_URL}/parc/${identifier}`
  }
  return `${STOREFRONT_BASE_URL}/s/${identifier}`
}

export function getStorefrontBaseUrl() {
  return STOREFRONT_BASE_URL
}

export function getStorefrontStatsApiBaseUrl() {
  const configuredBaseUrl = String(process.env.REACT_APP_STOREFRONT_STATS_API_BASE_URL || "")
    .trim()
    .replace(/\/$/, "")

  if (configuredBaseUrl) return configuredBaseUrl

  const hostname = getBrowserHostname()
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:3000"
  }

  return STOREFRONT_BASE_URL
}
